module.exports = __webpack_public_path__ + "static/img/food-policy01.b0a11f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/food-policy01.png
// module id = RNA9
// module chunks = 1